import * as CONFIG from "../../config.js";

export function ModLog(moduleName, actionName, ...vars) {
    if (CONFIG.Debug) {
        console.log(moduleName, actionName, ...vars);
    }
}
